export const employeeName = (employee) => (
  `${employee.firstName} ${employee.lastName} (${employee.role})`
)